<div class="card p-3 flex flex-col gap-4 mt-2">
  <nz-skeleton [nzLoading]="loading" [nzActive]="true">
    <div class="title">Go Live Document</div>
    <hr>
  </nz-skeleton>
  <app-shipping-delivery *ngIf="packageUser === '3'" [docState]="shippingDocState" (stateUpdated)="getDocState()"></app-shipping-delivery>
  <app-payment-service-document [docState]="paymentDocState" (stateUpdated)="getDocState()"></app-payment-service-document>
  <app-qrisly-service-doc [docState]="qrislyDocState" (stateUpdated)="getDocState()"></app-qrisly-service-doc>
</div>

<app-modal-doc-info [(isVisible)]="isVisible" (isVisibleChange)="isVisibleChange($event)"></app-modal-doc-info>
